import { FC } from 'react';

import wreathSvg from './images/wreath.svg';

/**
 * Avatar Wreath Overlay
 * Adds festive wreath decorations around all avatars when winter theme is active
 */
export const AvatarWreath: FC = () => {
	return (
		<style>
			{`
				/* Target links and divs that contain avatars and add wreath overlay */
				.winter-theme a:has([data-testid^="avatar-"]),
				.winter-theme div:has(> [data-testid^="avatar-"]) {
					position: relative;
					display: inline-block;
					overflow: visible !important;
				}

				.winter-theme a:has([data-testid^="avatar-"])::after,
				.winter-theme div:has(> [data-testid^="avatar-"])::after {
					content: '';
					position: absolute;
					top: 50%;
					left: 50%;
					transform: translate(-50%, -50%);
					width: 140%;
					height: 140%;
					background-image: url("${wreathSvg}");
					background-size: contain;
					background-repeat: no-repeat;
					background-position: center;
					pointer-events: none;
					z-index: 10;
				}

				/* Keep avatar overflow hidden for proper image cropping */
				.winter-theme [data-testid^="avatar-"] {
					overflow: hidden !important;
				}

				/* Disable wreaths for avatars inside comment sections */
				.winter-theme [data-testid="comments-container"] a:has([data-testid^="avatar-"])::after,
				.winter-theme [data-testid="comment"] a:has([data-testid^="avatar-"])::after,
				.winter-theme [data-testid="comment-stack"] a:has([data-testid^="avatar-"])::after {
					display: none !important;
				}
			`}
		</style>
	);
};
